var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 6.88942 6.88942 2.75 12 2.75C14.5221 2.75 16.8062 3.75711 18.475 5.39275C18.7708 5.68269 19.2457 5.67791 19.5356 5.38209C19.8256 5.08627 19.8208 4.61142 19.525 4.32149C17.5869 2.42198 14.93 1.25 12 1.25C6.06099 1.25 1.25 6.06099 1.25 12C1.25 13.3045 1.45947 14.4843 1.77737 15.5481C1.85896 15.8211 2.0882 16.0243 2.36902 16.0725C2.64985 16.1207 2.93374 16.0057 3.10174 15.7755L5.93911 11.8886C6.18333 11.554 6.11009 11.0848 5.77553 10.8406C5.44097 10.5964 4.97178 10.6696 4.72756 11.0042L2.86481 13.556C2.79126 13.0602 2.75 12.5421 2.75 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2225 8.45189C22.1409 8.17889 21.9116 7.97569 21.6308 7.92747C21.35 7.87924 21.0661 7.99431 20.8981 8.22445L18.0607 12.1114C17.8165 12.446 17.8897 12.9152 18.2243 13.1594C18.5589 13.4036 19.028 13.3304 19.2723 12.9958L21.135 10.444C21.2086 10.9398 21.2498 11.4579 21.2498 12C21.2498 17.1106 17.1104 21.25 11.9998 21.25C9.47775 21.25 7.19363 20.2429 5.52479 18.6072C5.22897 18.3173 4.75412 18.3221 4.46418 18.6179C4.17425 18.9137 4.17902 19.3886 4.47484 19.6785C6.4129 21.578 9.06979 22.75 11.9998 22.75C17.9388 22.75 22.7498 17.939 22.7498 12C22.7498 10.6954 22.5404 9.51564 22.2225 8.45189Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8C13.3807 10.8 14.5 9.72548 14.5 8.4C14.5 7.07452 13.3807 6 12 6C10.6193 6 9.5 7.07452 9.5 8.4C9.5 9.72548 10.6193 10.8 12 10.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12C7.55964 12 7 12.5373 7 13.2C7 15.851 9.23858 18 12 18C14.7614 18 17 15.851 17 13.2C17 12.5373 16.4404 12 15.75 12H8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReload);
export default __webpack_public_path__ + "static/media/user-reload.a50d7bedf31c4a1871b2159a4f7d6e62.svg";
export { ForwardRef as ReactComponent };